export default function(i) {
    var images = require.context("../../../assets/countries", false, /\.svg$/);
    return images("./" + i + ".svg");
}
